import {LinkButton} from "@atlaskit/button/new";
import type {ComponentProps} from "react";

export function AnankeLinkButton(props: ComponentProps<typeof LinkButton>) {
    return <LinkButton {...props} />;
}
